import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import PartnerSection from '../../components/PartnerSection';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import WorkProcess from '../../components/WorkProcess/WorkProcess';
import IndustrieSection from '../../components/IndustrieSection/IndustrieSection';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import TeamSection from '../../components/TeamSection/TeamSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import FaqSection from '../../components/FaqSection/FaqSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import FeaturesService from '../../components/Help-Desk-Components/FeaturesService/FeaturesService';
import VideoService from '../../components/Help-Desk-Components/VideoService/VideoService';
import FeatureSection from '../../components/Help-Desk-Components/FeatureSection/FeatureSection';
import FunFactSection from '../../components/Help-Desk-Components/FunFact/FunFact';
import WorkFlow from '../../components/Cloud-devops-components/WorkFlow/WorkFlow';
import ServiceSection2 from '../../components/data-solutions-components/ServiceSection/ServiceSection';
import Header2 from '../../components/Header2/Header2';
import Hero2 from '../../components/hero2/hero2';
import ServiceSection3 from '../../components/It-Services-Components/ServiceSection/ServiceSection';

import About2 from '../../components/It-Services-Components/about/about';
import WhyChoose from '../AboutUsPage/WhyChoose';

const HomePage = () => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        {/* <Header /> */}
        <Header2 />
        <main className="page_content">
          {/* <Hero /> */}
          <Hero2 />
          {/* <About2 />
          <ServiceSection3 />
          <FeaturesService />
          <VideoService />
          <FeatureSection />
          <PartnerSection />
          <FunFactSection />
          <WorkFlow />
          <WhyChoose />
          <About /> */}
          {/* <ServiceSection /> */}
          {/* <ServiceSection2 />
          <ProjectSection />
          <WorkProcess />
          <IndustrieSection />
          <Testimonial />
          <FeaturesSection />
          <TeamSection /> */}
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default HomePage;
